import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import s from './index.module.scss';

type TableItemStatusProps = {
	status: string;
	isRed: boolean;
	isGreen: boolean;
	isBlue?: boolean;
	isYellow?: boolean;
};

export const TableItemStatus: FC<TableItemStatusProps> =
	({ status, isRed, isGreen, isBlue, isYellow }) => {
	const { t } = useTranslation();

	return (
		<div className={s.root}>
			<div
				className={classNames(s.text, {
					[s.textRed]: isRed,
					[s.textGreen]: isGreen,
					[s.textBlue]: isBlue,
					[s.textYellow]: isYellow,
				})}
			>
				{t(status)}
			</div>
		</div>
	);
};
